import React from 'react';
import { Page } from '../Page';
import { Beef, Carrot, Wheat } from 'lucide-react';
export function Page5b() {
  return <Page pageNumber={24} variant="light" data-id="element-965" data-mp="2fpwd1395i202">
      <div className="flex flex-col h-full" data-id="element-966" data-mp="2ft24uq95zhzh">
        <div className="mb-8 pt-4" data-id="element-967" data-mp="2krby2vbbw8ig">
          <p className="text-[10px] font-bold text-tealslate uppercase tracking-[0.2em] mb-3" data-id="element-968" data-mp="2ko7mvdzg4cia">
            Practical Tools
          </p>
          <h1 className="text-5xl font-serif text-[#1F1F1F] leading-tight mb-4" data-id="element-969" data-mp="1s1wkpyw6y3jd">
            The Fist <span className="text-tealslate" data-id="element-970" data-mp="1x0gbcclqc3i2">Method</span>
          </h1>
          <div className="w-16 h-0.5 bg-tealslate" data-id="element-971" data-mp="1wyn34svgxb7y" />
        </div>

        <p className="text-sm text-[#3B3B3B] leading-[1.8] mb-10 max-w-lg" data-id="element-972" data-mp="21z0zvermcyqo">
          If you are eating out, traveling, or just don't want to think about
          fractions of a plate, use your hand. It's scaled to your body size and
          always with you.
        </p>

        <div className="space-y-6 mb-10" data-id="element-973" data-mp="1e9or2g07esow">
          <div className="flex items-start gap-5 bg-[#EAEAE4] border border-[#D8D8D0] p-6" data-id="element-974" data-mp="1e8dqsq5yw32j">
            <div className="w-12 h-12 rounded-full bg-tealslate flex items-center justify-center shrink-0" data-id="element-975" data-mp="2i1nb8vidncvo">
              <Beef className="w-6 h-6 text-white" data-id="element-976" data-mp="2d3u3hy1feata" />
            </div>
            <div data-id="element-977" data-mp="28bai4ewhybdx">
              <h2 className="text-sm font-bold text-[#1F1F1F] mb-1" data-id="element-978" data-mp="28asntntea78n">
                Protein = Palm of Your Hand
              </h2>
              <p className="text-xs text-[#7A7A70] leading-[1.8]" data-id="element-979" data-mp="248xjsbk2xfr6">
                A portion of meat, fish, or poultry should be roughly the size
                and thickness of your palm (about 3-4 oz or 20-30g of protein).
              </p>
            </div>
          </div>

          <div className="flex items-start gap-5 bg-[#EAEAE4] border border-[#D8D8D0] p-6" data-id="element-980" data-mp="1pdrfpu4jnr0h">
            <div className="w-12 h-12 rounded-full bg-navyslate flex items-center justify-center shrink-0" data-id="element-981" data-mp="1ldpc3ff90nik">
              <Carrot className="w-6 h-6 text-white" data-id="element-982" data-mp="3jpeka8d8n5u2" />
            </div>
            <div data-id="element-983" data-mp="3fr8fv6zvh2cb">
              <h2 className="text-sm font-bold text-[#1F1F1F] mb-1" data-id="element-984" data-mp="3fqowrmyhk7wp">
                Vegetables = Your Fist
              </h2>
              <p className="text-xs text-[#7A7A70] leading-[1.8]" data-id="element-985" data-mp="1htymgemtutur">
                Aim for at least one fist-sized portion of non-starchy
                vegetables with lunch and dinner.
              </p>
            </div>
          </div>

          <div className="flex items-start gap-5 bg-[#EAEAE4] border border-[#D8D8D0] p-6" data-id="element-986" data-mp="185714pc9v7st">
            <div className="w-12 h-12 rounded-full bg-bluegray flex items-center justify-center shrink-0" data-id="element-987" data-mp="1vthvrardkb8n">
              <Wheat className="w-6 h-6 text-white" data-id="element-988" data-mp="20rrs3oou5hvu" />
            </div>
            <div data-id="element-989" data-mp="1mtbinpzl9da0">
              <h2 className="text-sm font-bold text-[#1F1F1F] mb-1" data-id="element-990" data-mp="1mtuquezfsnau">
                Carbs = Cupped Hand
              </h2>
              <p className="text-xs text-[#7A7A70] leading-[1.8]" data-id="element-991" data-mp="1rql6503f3ev7">
                A portion of rice, potatoes, pasta, or fruit should fit into
                your cupped hand.
              </p>
            </div>
          </div>
        </div>

        <div className="flex-1 flex flex-col justify-end" data-id="element-992" data-mp="7vyuidff45o0">
          <p className="text-xs text-[#3B3B3B] leading-[1.8] mb-6 italic text-center" data-id="element-993" data-mp="7ue2augksytb">
            <strong className="text-tealslate" data-id="element-994" data-mp="3tlso03skrwi">Important:</strong> On GLP-1
            medication, always eat your protein first. You may not finish
            everything on your plate, and that is perfectly fine.
          </p>

          {/* Stat Bar */}
          <div className="flex w-full h-16 text-white text-xs font-bold uppercase tracking-wider" data-id="element-995" data-mp="3lalrmtkc1o9g">
            <div className="flex-1 bg-tealslate flex items-center justify-center border-r border-[#F5F5F0]" data-id="element-996" data-mp="3gc23qnm6i2eg">
              Palm = 20-30g Protein
            </div>
            <div className="flex-1 bg-navyslate flex items-center justify-center border-r border-[#F5F5F0]" data-id="element-997" data-mp="3v1zn8q95y3xb">
              Fist = 1 cup Veggies
            </div>
            <div className="flex-1 bg-bluegray flex items-center justify-center" data-id="element-998" data-mp="32jc5nktdl70z">
              Cup = 1/2 cup Carbs
            </div>
          </div>
        </div>
      </div>
    </Page>;
}